import { Pipe, ChangeDetectorRef, PipeTransform, OnDestroy, NgZone } from '@angular/core';
import moment, { duration } from 'moment';
import { interval, isObservable, Observable, of, timer } from 'rxjs';
import { map, share, startWith, switchMap } from 'rxjs/operators';
import { Duration } from 'moment/moment';

@Pipe({ name: 'amTimeAgoUpdateEverySecond$' })
export class AmTimeAgoUpdateEverySecondPipe implements PipeTransform {
   private static interval$ = interval(1000).pipe(share());

   transform(inputValue: Date | Observable<Date> | moment.Moment | Observable<moment.Moment>): Observable<Duration> {
      const inputValue$ = isObservable(inputValue) ? inputValue : of(inputValue);

      return inputValue$.pipe(
         map((value) => moment(value)),
         switchMap((value: moment.Moment) =>
            AmTimeAgoUpdateEverySecondPipe.interval$.pipe(
               startWith(value),
               map(() => value)
            )
         ),
         map((value) => {
            if (moment() < value) {
               return moment.duration(value.diff(moment()));
            } else {
               return moment.duration(moment().diff(value));
            }
         })
      );
   }
}
